import '@/installFineMq'

import ScrollToTopModule from '@/modules/scrollToTop/ScrollToTopModule'
import { mount } from '@/mounter'

mount('scroll-to-top', ScrollToTopModule)
